export enum SuccessActionCode {
  RedirectToSuccessPage = 0,
  RedirectToPayment = 1,
  RedirectToAppointment = 2,
  RedirectToAttachments = 3
}
